import { useRouter } from 'next/router';
import { FC, useCallback, useEffect } from 'react';
import styled from 'styled-components';

interface KakaoShareButtonProps {
  examInfo: any;
  label: string;
  logoImagePng: string;
  kakaoServiceKey: string;
}

const ShareButtonKakao: FC<KakaoShareButtonProps> = ({
  examInfo,
  label,
  logoImagePng,
  kakaoServiceKey,
}) => {
  const router = useRouter();
  const examIdx = router.query?.examIdx;

  const stripHtmlTags = (input: any) => {
    if (typeof input !== 'string') {
      return input;
    }
    return input.replace(/<\/?[^>]+(>|$)/g, '');
  };

  const description = stripHtmlTags(examInfo?.description);

  const createKakaoButton = () => {
    const shareLink = `${window.location.origin}/exam/detail/${examIdx}`;
    // kakao sdk script이 정상적으로 불러와졌으면 window.Kakao로 접근이 가능합니다
    if (window.Kakao) {
      const kakao = window.Kakao;
      // 중복 initialization 방지
      if (!kakao.isInitialized()) {
        // 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
        kakao.init(kakaoServiceKey);
      }
      kakao.Link.createDefaultButton({
        // Render 부분 id=kakao-link-btn 을 찾아 그부분에 렌더링을 합니다
        container: '#kakao-link-btn',
        objectType: 'feed',
        installTalk: true,
        content: {
          title: label,
          description: description,
          imageUrl: examInfo?.examUrl ?? `${window.location.origin}${logoImagePng}`,
          link: {
            mobileWebUrl: shareLink,
            webUrl: shareLink,
          },
        },
        buttons: [
          {
            title: '웹에서 보기',
            link: {
              mobileWebUrl: shareLink,
              webUrl: shareLink,
            },
          },
        ],
      });
    }
  };

  useEffect(() => {
    createKakaoButton();
  }, []);

  return (
    <div id="kakao-link-btn">
      <StyledButton aria-label="Kakao로 공유하기" />
    </div>
  );
};

export default ShareButtonKakao;

const StyledButton = styled.button`
  display: inline-block;
  width: 30px;
  height: 30px;
  background-size: cover;
  cursor: pointer;
  border: none;
  padding: 0;
  background-image: url('/icons/share-kakao-new.png');
`;
